exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .shopify-1{\n    stroke:#707070;\n  }\n  .shopify-2{\n    clip-path:url(#clip-path);\n  }\n  .shopify-3{\n    fill:#95bf47;\n  }\n  .shopify-4{\n    fill:#5e8e3e;\n  }\n  .shopify-5{\n    fill:#fff;\n  }", ""]);
